import { use } from 'react';
import { PageLoadingProviderContext } from './PageTransitionProvider';

export const usePageLoading = () => use(PageLoadingProviderContext);
